import {
defineCustomElement,
MediaControlsElement,
MediaControlsGroupElement
} from "vidstack/elements";

defineCustomElement(MediaControlsElement);
defineCustomElement(MediaControlsGroupElement);